import { type SoapSectionKeys } from '@/shared/types/yakurekiSoap'

// 「選んで入れる」定型文。back の anycompass.SoapSet と 1:1。

// SOAP 区分。back の SOAP_ABBREVIATION_MAPPING と同じ綴り。
export type SoapMasterType = 'S' | 'O' | 'A' | 'EP' | 'CP' | 'OP'

// SOAP 区分 → Kakeru の section キー。back の SOAP_ABBREVIATION_MAPPING と同じ対応。
export const SOAP_TYPE_TO_SECTION: Record<SoapMasterType, SoapSectionKeys> = {
  S: 'subjectives',
  O: 'objectives',
  A: 'assessments',
  EP: 'educational_plans',
  CP: 'care_plans',
  OP: 'observational_plans',
}

// 挿入先を選ばせるときのボタンの並び。SOAP の読み順そのもの。
export const SOAP_TYPE_ORDER: SoapMasterType[] = [
  'S',
  'O',
  'A',
  'EP',
  'CP',
  'OP',
]

// 指導文 1 行。
//
// soap_type が null になるのは**旧 文章マスタから移行した行だけ**で、新規作成では back が必須にする
// (= 構造的に単調減少する)。null の行は挿入時に薬剤師が 6 区分から選ぶ。
// 並びは配列順が正 (移行元の連番は持たない)。
export interface SoapSetLine {
  soap_type: SoapMasterType | null
  content: string
}

// 定型文 1 件。同定は (店舗, 作成者, キー) で、キー単独ではない
// (移行元はキーを薬剤師ごとに 1 から振り直しているため)。
export interface SoapSet {
  id: string
  set_key: string
  condition1: string
  condition2: string
  author_name: string
  lines: SoapSetLine[]
}

// 作成・更新で送る形。set_key は出所の記録なので back が発番し、front からは触らない。
export interface SoapSetInput {
  condition1: string
  condition2: string
  author_name: string
  lines: SoapSetLine[]
}
